import { Dialog, Transition } from '@headlessui/react';
import { ExclamationIcon } from '@heroicons/react/solid';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useActionModal } from '../../hooks/ActionModal.hook';

interface SaveAlertProps {
  id: string;
}
export default function SaveAlertModal({
  id,
}: SaveAlertProps) {
  const { savePanel } = useActionModal();
  const { t } = useTranslation();
  const history = useHistory();
  const handleOnClick = () => {
    history.push(`/panels/${id}`);
    savePanel.close();
  };

  return (
    <Transition show={savePanel.isOpen} as={Fragment}>
      <Dialog
        as="div"
        id="Save Error"
        open={savePanel.isOpen}
        onClose={savePanel.close}
        className="fixed inset-0 z-10 overflow-y-auto"
      >
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                <ExclamationIcon className="h-6 w-6 text-yellow-600" />
              </div>
              <Dialog.Title
                as="h3"
                className="text-lg font-medium text-center leading-6 text-gray-900 pt-4"
              >
                {t('panel.modal.saveErrorHeader')}
              </Dialog.Title>
              <div className="mt-2 text-center">
                <p className="text-sm text-gray-500">
                  {t('panel.modal.saveErrorDetail')}
                </p>
              </div>

              <div className="mt-4 text-center space-x-2">
                <button
                  type="button"
                  className="inline-flex justify-center px-4 py-2 text-sm font-medium text-yellow-600 bg-yellow-100 border border-transparent rounded-full hover:bg-yellow-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-yellow-500"
                  onClick={savePanel.close}
                >
                  {t('panel.modal.editPanelButton')}
                </button>
                <button
                  type="button"
                  className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-yellow-400 border border-transparent rounded-full hover:bg-yellow-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-yellow-500"
                  onClick={handleOnClick}
                >
                  {t('panel.modal.viewPanelButton')}
                </button>
                <input type="hidden" className='sr-only' />
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}